// @ts-check

const DEFAULT_TERMS_URL = '//www.ringba.com/terms';
const LINK_URL = /^(https?:)?\/\//i;

/**
 * Returns the URL the terms label links to, or `null` when the label must not be a link.
 *
 * Links:
 * - An empty URL links to Ringba's terms.
 * - Only `http:`, `https:` and protocol-relative URLs are links.
 *
 * @param {string | undefined} url
 * @returns {string | null}
 */
export function getTermsLinkUrl(url) {
  const linkUrl = url || DEFAULT_TERMS_URL;
  return LINK_URL.test(linkUrl) ? linkUrl : null;
}
